import React from "react";
import Loader from "./Loader";

export default function Suspense({ children }: React.PropsWithChildren) {
  return <React.Suspense fallback={<Loader />}>{children}</React.Suspense>;
}
